<template>

    <MenuFinancialCompact/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h2>Hello {{ this.profile.firstName }}</h2>

                    <br>
                    <h3>What Would You Like to Do Today?</h3>
                    <li @click="processClientMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>Add or view clients?</span>
                    </li>

                    <li @click="processAppointmentMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>Create and manage appointments?</span>
                    </li>

                    <li @click="processInvoicesMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>View and manage invoices?</span>
                    </li>

                    <li @click="processPaymentsMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>View and manage payments?</span>
                    </li>

                </div>

<!--                <br><br>-->
<!--                <h3>Here is a breakdown of some important information...</h3>-->

<!--                <div class="grid">-->
<!--                    <div class="col-12 lg:col-4 p-3">-->

<!--                        <div class="shadow-2 surface-card p-3" style="border-radius: 12px">-->
<!--                            <div class="flex align-items-center justify-content-between">-->
<!--                                <div>-->
<!--                                    <span class="text-3xl text-900 font-bold">This Month</span>-->
<!--                                    <p>&nbsp;</p>-->
<!--                                    <p class="mt-2 mb-0 text-600 text-xl">Income is-->
<!--                                        {{ this.formatAmount(this.financialSummary.invoiceSummary) }}</p>-->
<!--                                    <p class="mt-2 mb-0 text-600 text-xl">Payments are-->
<!--                                        {{ this.formatAmount(this.financialSummary.paymentSummary) }}</p>-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    <img src="/images/blocks/illustration/stats-illustration-4.svg"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-12 lg:col-4 p-3">-->
<!--                        <div class="shadow-2 surface-card p-3" style="border-radius: 12px">-->
<!--                            <div class="flex align-items-center justify-content-between">-->
<!--                                <div>-->
<!--                                    <span class="text-3xl text-900 font-bold">Last Month</span>-->
<!--                                    <p>&nbsp;</p>-->
<!--                                    <p class="mt-2 mb-0 text-600 text-xl">Income was-->
<!--                                        {{ this.formatAmount(this.financialSummary.invoiceSummaryPreviousMonth) }}</p>-->
<!--                                    <p class="mt-2 mb-0 text-600 text-xl">Payments were-->
<!--                                        {{ this.formatAmount(this.financialSummary.paymentSummaryPreviousMonth) }}</p>-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    <img src="/images/blocks/illustration/stats-illustration-5.svg"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="col-12 lg:col-4 p-3">-->
<!--                        <div class="shadow-2 surface-card p-3" style="border-radius: 12px">-->
<!--                            <div class="flex align-items-center justify-content-between">-->
<!--                                <div>-->
<!--                                    <span class="text-3xl text-900 font-bold">Two Months Ago</span>-->
<!--                                    <p>&nbsp;</p>-->
<!--                                    <p class="mt-2 mb-0 text-600 text-xl">Income was-->
<!--                                        {{ this.formatAmount(this.financialSummary.invoiceSummaryTwoMonthsAgo) }}</p>-->
<!--                                    <p class="mt-2 mb-0 text-600 text-xl">Payments were-->
<!--                                        {{ this.formatAmount(this.financialSummary.paymentSummaryTwoMonthsAgo) }}</p>-->
<!--                                </div>-->
<!--                                <div>-->
<!--                                    <img src="/images/blocks/illustration/stats-illustration-6.svg"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <br><br>
                <h3>These are the last twenty actions completed on your account...</h3>

                <ul class="p-0 m-0 list-none">
                    <li v-for="(trail, index) in auditTrails" :key="index"
                        class="flex align-items-center py-2 border-bottom-1 surface-border">
                        <div v-if="trail.mainProcess === 'Invoicing Process'"
                             class="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0">
                            <i class="pi pi-dollar text-xl text-blue-500"></i>
                        </div>
                        <div v-else-if="trail.mainProcess === 'Calendar'"
                             class="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0">
                            <i class="pi pi-arrow-up text-xl text-blue-500"></i>
                        </div>
                        <div v-else
                             class="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0">
                            <i class="pi pi-question text-xl text-blue-500"></i>
                        </div>
                        <span class="text-900 line-height-3 font-normal">
                                            {{ trail.description }}
                                        </span>

                    </li>
                </ul>

            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import DashboardService from "@/service/DashboardService";
import AuditTrailService from "@/service/AuditTrailService";

export default {
    components: {
        IsoEvolveFooter, MenuFinancialCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            }

            this.profile = this.userStore.user;

            try {
                const [financialSummaryData, auditTrailsData] = await Promise.all([
                    DashboardService.getFinancialSummaryOverThreeMonthsForCompany(this.profile.companyId),
                    AuditTrailService.getCompanyAuditTrailsLastTwenty(this.profile.companyId)
                ]);

                this.financialSummary = financialSummaryData.data;
                this.auditTrails = auditTrailsData.data;

                this.loading = false;

            } catch (e) {
                console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
            }

        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] No user data found.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
        }
    },
    data() {

        return {
            profile: {},
            financialSummary: {},
            auditTrails: null,
        }
    },
    methods: {
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        processClientMenu() {
            this.$router.push("commonClients");
        },
        processAppointmentMenu() {
            this.$router.push("commonAppointments");
        },
        processPaymentsMenu() {
            this.$router.push("commonFinancialPayments");
        },
        processInvoicesMenu() {
            this.$router.push("commonFinancialInvoices");
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
